var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconSendQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.33331L7.26 8.83998C7.47911 8.98616 7.7366 9.06418 8 9.06418C8.2634 9.06418 8.52089 8.98616 8.74 8.83998L14 5.33331M3.33333 12.6666H12.6667C13.0203 12.6666 13.3594 12.5262 13.6095 12.2761C13.8595 12.0261 14 11.6869 14 11.3333V4.66665C14 4.31302 13.8595 3.97389 13.6095 3.72384C13.3594 3.47379 13.0203 3.33331 12.6667 3.33331H3.33333C2.97971 3.33331 2.64057 3.47379 2.39052 3.72384C2.14048 3.97389 2 4.31302 2 4.66665V11.3333C2 11.6869 2.14048 12.0261 2.39052 12.2761C2.64057 12.5262 2.97971 12.6666 3.33333 12.6666Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSendQuote);
export default __webpack_public_path__ + "static/media/common_icon_send_quote.6c4646bf9ad061bd3764d4c40146d76a.svg";
export { ForwardRef as ReactComponent };